<template>
  <div class="voucher">
    <div v-if="isApplied" class="voucher-price">
      <div class="price">
        <div class="final" v-html="discount" />
      </div>
      <a href="#" class="remove" @click.prevent="remove">
        <i class="fa fa-remove text-is-danger" />
      </a>
    </div>
    <div v-if="!isApplied" class="field has-addons">
      <p class="control">
        <input
          v-model="code"
          :placeholder="$t('voucher.enter_code')"
          class="input is-medium"
          @keyup.enter="apply"
        />
      </p>
      <p class="control">
        <button
          type="button"
          class="button is-flts-blue is-medium"
          @click="apply"
        >
          {{ $t('voucher.apply') }}
        </button>
      </p>
    </div>
    <p v-if="error" class="help is-danger" v-text="error" />
  </div>
</template>

<style lang="scss">
.voucher-price {
  position: relative;
  & .remove {
    position: absolute;
    top: 0;
    right: -2em;
    & i {
      font-size: 1em;
    }
  }
}
</style>

<script>
import PriceFormatter from '../../mixins/PriceFormatter';

export default {
  name: 'Voucher',

  mixins: [PriceFormatter],

  data() {
    return {
      error: null,
      code: ''
    };
  },

  computed: {
    isApplied() {
      return !!this.$store.getters.totals.voucher_discount;
    },

    discount() {
      return this.isApplied
        ? this.formatPrice(this.$store.getters.totals.voucher_discount * -1)
        : '';
    }
  },

  methods: {
    apply() {
      this.error = null;

      if (!this.code) {
        this.error = this.$t('exceptions.voucher.required');
      } else {
        axios
          .post(`/voucher/apply/${escape(this.code)}`)
          .then(({ data }) => {
            this.$store.dispatch('updateTotals', data.cart.meta);
            flash(this.$t('voucher.success'));
          })
          .catch(({ response }) => {
            if (response.data.message) {
              this.error = response.data.message;
              error(response.data.message);
            }
          });
      }
    },

    remove() {
      if (this.isApplied) {
        axios
          .delete('/voucher/remove')
          .then(({ data }) => {
            this.$store.dispatch('updateTotals', data.cart.meta);
          })
          .catch(() => {});
      }
    }
  }
};
</script>
